import { BUSCAR_ENCOMENDAS_AVULSAS } from '../../actions/types'

const initial = { encomendasAvulsas: [], total: 0 }

export default function reducerBuscarEncomendasAvulsas (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_ENCOMENDAS_AVULSAS: {
      return {
        encomendasAvulsas: action.payload.encomendasAvulsas || [],
        total: action.payload.total || 0
      }
    }

    default:
      return state
  }
}
